import { library } from '@fortawesome/fontawesome-svg-core'
import { faGoogle, faIntercom, faSlack } from '@fortawesome/free-brands-svg-icons'
import { faCog, faComments, faFileCsv, faFileImage, faImage, faLockAlt, faLockOpenAlt, faPlusSquare, faSadTear, faSpinnerThird, faUser } from '@fortawesome/pro-duotone-svg-icons'
import {
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faBell,
  faCaretUp,
  faCheck,
  faChevronRight,
  faComment,
  faPlus,
  faTimes,
  faTimesCircle,
  faUndo
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'
import io from './io'
library.add(
  faSlack,
  faIntercom,
  faPlus,
  faGoogle,
  faPlusSquare,
  faCaretUp,
  faAngleDown,
  faComments,
  faFileImage,
  faUser,
  faTimes,
  faTimesCircle,
  faCog,
  faImage,
  faFileCsv,
  faLockAlt,
  faLockOpenAlt,
  faBell,
  faComment,
  faArrowRight,
  faArrowLeft,
  faSpinnerThird,
  faCheck,
  faUndo,
  faChevronRight,
  faSadTear
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import AlertBox from '@/components/helpers/AlertBox'
Vue.component('AlertBox', AlertBox)

import SubmitButton from '@/components/helpers/SubmitButton'
Vue.component('SubmitButton', SubmitButton)

import DropdownMenu from '@/components/helpers/DropdownMenu'
Vue.component('DropdownMenu', DropdownMenu)

import UserAvatar from '@/components/UserAvatar'
Vue.component('UserAvatar', UserAvatar)

import StatusLabel from '@/components/StatusLabel'
Vue.component('StatusLabel', StatusLabel)

import FeatureBlocker from '@/plugins/FeatureBlocker'
Vue.use(FeatureBlocker)

import DialogBox from '@/plugins/DialogBox'
Vue.use(DialogBox)

import ToastBox from '@/plugins/ToastBox'
Vue.use(ToastBox)

//https://github.com/ankurk91/vue-toast-notification
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'

Vue.use(VueToast)

import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

import moment from 'moment'
import vueMoment from 'vue-moment'
moment.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s',
    s: '<1m ago',
    ss: '<1m ago', // '%d seconds',
    m: '1m ago',
    mm: '%dm ago',
    h: '1h ago',
    hh: '%dh ago',
    d: '1d ago',
    dd: '%dd ago',
    M: '1mo ago',
    MM: '%dmos ago',
    y: '1y ago',
    yy: '%dy ago'
  }
})
Vue.use(vueMoment, { moment })

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

if (process.env.USE_BUGSNAG) {
  Bugsnag.start({
    apiKey: process.env.VUE_BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()]
  })

  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
} else {
  console.log(io) //dont remove this ;-)
}
